import { BookOpenCheckIcon, DropletsIcon, EggIcon, ScanSearchIcon, WorkflowIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Bonus = {
  number: string;
  title: string;
  description: string;
  icon: LucideIcon;
};

export const bonuses: Bonus[] = [
  {
    number: '1',
    title: 'HACCP Step-by-Step Visual Guide',
    description: 'The preliminary steps and the seven HACCP principles, explained visually one step at a time.',
    icon: WorkflowIcon,
  },
  {
    number: '2',
    title: 'Food Plant Sanitation & CIP Troubleshooting Guide',
    description: 'Common cleaning and CIP problems, their likely causes and what to check first.',
    icon: DropletsIcon,
  },
  {
    number: '3',
    title: 'Food Allergen Control Visual Guide',
    description: 'How allergens are controlled across receiving, storage, production, cleaning and labelling.',
    icon: EggIcon,
  },
  {
    number: '4',
    title: 'Foreign Body Prevention Field Guide',
    description: 'Sources of physical contaminants on the plant floor and the controls used to prevent them.',
    icon: ScanSearchIcon,
  },
  {
    number: '5',
    title: 'Food Processing & Food Safety Terminology Dictionary',
    description: 'An A–Z reference of the terms and acronyms used in food processing, hygiene, microbiology, food safety and quality.',
    icon: BookOpenCheckIcon,
  },
];
